<template>
    <el-drawer class="font-size14" size="800px"
               title="活动设置面板"
            :visible.sync="drawer"
            direction="rtl"
            :before-close="handleClose">
        <div style="padding: 0 10px; overflow-y: auto;height: calc(100vh - 100px);" class="flex">
            <toolsActivity ref="toolsActivity"></toolsActivity>
        </div>
    </el-drawer>
</template>
<script>
  import App from '../../util/comfun'
  import toolsActivity from '../tools/activity.vue'
  const verifyOptionLable=['','密码','','公众号','预设名单']
  export default {
    components: {
      toolsActivity,
    },
    props:{
    },
    data () {
      return {
        activeNames: ["tools","other","rules","function","customize"],
        drawer: false,
        detail:{activityAuth:{}},
        limit:{},
        verifyOption:[],
        residualDownloadTraffic:0,
        form:{type:[]},
        ruleVideo:{},
        rulePicture:{},
        codeurl:'',
        detailBrowse:'',
        VERSIONS:{},
      }
    },
    methods:{
      MG:App.MG,
      show(activity){
        this.activity=activity
        this.drawer=true
        setTimeout(()=>{
          this.$refs.toolsActivity.show(activity)
        },0)
        return

        setTimeout(()=>{
          this.loading=this.$loading({text:'loading...',target:'.el-drawer'})
        },0)
        this.getDetail()
        this.VERSIONS=wxlite.VERSIONS
      },
      handleClose(done){
        done()
      },
      async getDetail(){
        this.verifyOption=[]
        let res=await App.demand('/activity/materialRule/limit/{activityId}','GET',{activityId:this.activity.id})
        res.data.videoDuration=Math.ceil(res.data.videoDuration/60)
        res.data.audioDuration=Math.ceil(res.data.audioDuration/60)
        this.limit=res.data
        App.Contribution.GetContributionById({activityId:this.activity.id}).then(async res=>{
          let userRes=await App.demand('/user/info','GET',{
            userId:res.data.createBy,
          })
          res.data.residualDownloadTraffic=userRes.data.residualDownloadTraffic/1

          this.detail=res.data
          let verifyOption=this.detail.activityAuth.verifyOption.split('')
          console.log('verifyOption',verifyOption)
          verifyOption.forEach(idx=>{
            if(!verifyOptionLable[idx]) return;
            this.verifyOption.push(verifyOptionLable[idx])
          })
          if(['Video','PictureAndVideo','Mixin'].includes(this.detail.activityType)){
            this.detail.activityMaterialTypeRefs.some(rule=>{
              if(rule.activityMaterialType=='Video'){
                this.ruleVideo=rule
              }
              if(rule.activityMaterialType=='Picture'){
                this.rulePicture=rule
              }
            })
          }
          this.setQrcode()
          if(this.loading){
            this.loading.close()
            this.loading=null
          }
        })
      },
      async setQrcode(){
        this.codeurl=await App.System.Qrcode({
          autoColor:false,
          inHyaline:false,
          lineColor:'0,0,0',
          page:'pages/enter/enter',
          scene:encodeURIComponent('gotopath=/pages/pub/work='+this.detail.activityId),
          width:300
        },'URL')
      },
      verifyOptionChange(opt){
        let val=[0,2]
        opt.forEach(lab=>{
          val.push(verifyOptionLable.indexOf(lab))
        })
        val.sort()
        console.log('verifyOptionChange',val)
        return App.demand('/admin/activity/modifyVerifyOption','POST',{
          "activityId": this.activity.id,
          "optionList": val
        })
      },
      adSetting(val){
        console.log(val)
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/adSetting','POST',{
          "activityId": this.activity.id,
          "conceal": val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      restrictAccess(val){
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/restrictAccess','GET',{
          "activityId": this.activity.id,
          "enable": val?1:0,
        }).then(()=>{
          this.getDetail()
        })
      },
      publicSetting(val){
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/publicSetting','GET',{
          activityId:this.activity.id,
          isPublic:val?1:0,
        }).then(()=>{
          this.getDetail()
        })
      },
      trafficAdd(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('admin/trafficAdd','GET',{
          activityId:this.activity.id,
          traffic:val*1024*1024,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      maxOrderNumSet(){
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/publicActivityAdjustSeq','GET',{
          activityId:this.activity.id,
          order:parseInt(new Date()/1000),
        }).then(()=>{
          if(this.loading){
            this.loading.close()
            this.loading=null
          }
          this.$message({
            showClose: true,
            message: '置顶成功',
            type: 'success'
          });
        })
      },
      materialRuleLimit(){
        if(this.hasautoUping){
          let limitData=JSON.parse(JSON.stringify(this.limit))
          limitData.videoDuration=limitData.videoDuration*60
          limitData.audioDuration=limitData.audioDuration*60
          return App.demand('/admin/activity/materialRuleLimit','POST',limitData)
        }else{
          this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
          setTimeout(()=>{
            let limitData=JSON.parse(JSON.stringify(this.limit))
            limitData.videoDuration=limitData.videoDuration*60
            limitData.audioDuration=limitData.audioDuration*60
            App.demand('/admin/activity/materialRuleLimit','POST',limitData).then(()=>{
              this.getDetail()
            })
          },800)
        }
      },
      modifyCollaboratorLimit(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/modifyCollaboratorLimit','GET',{
          activityId:this.activity.id,
          count:val,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      modifyJudgesLimit(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/modifyJudgesLimit','GET',{
          activityId:this.activity.id,
          count:val,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableOriginVideo(val,uri){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand(uri,'GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableAnonymous(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/enableAnonymous','GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enablePresetName(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand('/admin/activity/enablePresetName','GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableEverydaySub(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/enableEverydaySub','GET',{
          activityId:this.activity.id,
          enable:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      modifyIsAnnex(val,type){
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        setTimeout(()=>{
          let isAnnex=this.detail.activityAuth.isAnnex
          let mustEnclosure=this.detail.activityAuth.mustEnclosure
          let params={
            "isAnnex": isAnnex,
            "isEnclosure":isAnnex,
            "enclosureTips": this.detail.activityAuth.enclosureTips||'',
            "mustEnclosure": mustEnclosure,
          }
          if(typeof val=='boolean'){
            params[type]=val?1:0
            params.isEnclosure=params.isAnnex
          }else{
            params[type]=val
          }
          //console.log('modifyIsAnnex',params)
          App.demand('/admin/activity/enclosureOper','POST',{
            "activityId": this.activity.id,
            ...params,
          }).then(()=>{
            this.getDetail()
          })
        },800)
      },
      modifyActivityVipStatus(val){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand('/admin/activity/modifyActivityVipStatus','GET',{
          activityId:this.activity.id,
          isVip:val?1:0,
        }).then(()=>{
          if(!this.hasautoUping) this.getDetail()
        })
      },
      enableOption(enable,api,key='enable',month='GET'){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        App.demand(api,month,{
          activityId:this.activity.id,
          [key]:enable?1:0,
        }).then((res)=>{
          if(res.code!=200) {this.loading.close();return this.$message(res.message)}
          if(!this.hasautoUping) this.getDetail()
        }).catch(res=>{
          console.log(res)
          this.loading.close()
          return this.$message(res.status+':'+res.url)
        })
      },
      modifyValue(val,key,api,month='GET'){
        if(!this.hasautoUping) this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        return App.demand(api,month,{
          activityId:this.activity.id,
          [key]:val,
        }).then(res=>{
          if(res.code!=200) {this.loading.close();return this.$message(res.message)}
          if(!this.hasautoUping) this.getDetail()
        }).catch(res=>{
          console.log(res)
          this.loading.close()
          return this.$message(res.status+':'+res.url)
        })
      },
      autoUp(){//一键提升vip权益
        this.loading=this.$loading({text:'设置中...',target:'.el-drawer'})
        this.hasautoUping=true
        this.limit={
          activityId: this.limit.activityId,
          audioCount: "2",
          audioDuration: "16",
          audioSize: "100",
          docCount: "2",
          docSize: "100",
          pictureCount: "20",
          pictureSize: "100",
          videoCount: "2",
          videoDuration: "16",
          videoSize: "500",
          wordCount: "5000",
        }
        let autoApi = [
          this.materialRuleLimit(),
          this.modifyCollaboratorLimit(100),//协作员
          this.modifyJudgesLimit(100),//评委数
          this.trafficAdd(102400),//100G
          this.adSetting(1),//ad
          this.verifyOptionChange(['密码', '公众号', '预设名单']),
          this.enableOriginVideo(1),//原视频

          this.enableAnonymous(1),//匿名
          this.enableEverydaySub(1),//每天投稿
          this.enablePresetName(1),//投稿预设名单
          this.enableOption(1, '/admin/activity/enableSubmissionLimitArea'),//限定投稿地区

          this.enableOption(1, '/admin/activity/enableAppoint'),//开通大众投票指定投稿功能
          this.enableOption(1, '/admin/activity/enableGrantMobile'),//开通大众投票授权手机号功能
          this.enableOption(1, '/admin/activity/enableAntiCheat'),//反刷票
          this.enableOption(1, '/admin/activity/enableVoteLimitArea'),//限定投票地区
          this.modifyActivityVipStatus(1),//vip标识
        ]
        Promise.all(autoApi).then(()=>{
          setTimeout(()=>{
            this.hasautoUping=false
            this.getDetail()
          },800)
        }).catch(()=>{
          setTimeout(()=>{
            this.hasautoUping=false
            this.getDetail()
          },800)
        })
      },
      async fixThumb(){
        //"{"type":"1","width":1125,"height":840,"name":"fotoocover","suffix":"","size":0}"
        if(this.detail.activityCovers.length!=1){
          return this.$message('只能修复单封面活动')
        }
        if(!this.hasautoUping) this.loading=this.$loading({text:'修复中...',target:'.el-drawer'})
        let cover=this.detail.activityCovers[0]
        let exif={"type":"1","width":this.detail.width,"height":this.detail.height,"name":cover.fileName||'',"suffix":'',"size":0}
        return App.demand('/activity/cover/save','POST',{
          activityId:this.activity.id,
          coverList:[{
            bucket: "fotoo",
            exif: JSON.stringify(exif),
            fileName: cover.fileName||'',
            hash: "",
            height: this.detail.height,
            id: 0,
            materialType: "PictureMaterialType",
            sequence: 0,
            suffix: '',
            url: cover.url,
            width: this.detail.width,
          },],
        }).then(res=>{
          if(res.code!=200) {this.loading.close();return this.$message(res.message)}
          if(!this.hasautoUping) this.getDetail()
          return this.$message.success('修复成功')
        }).catch(res=>{
          console.log(res)
          this.loading.close()
          return this.$message(res.status+':'+res.url)
        })
      },
      handleChange(){},
      addDialogEvent(e){
        App.demand('/user/info','GET',{
          userId:this.detail.createBy,
        }).then(res=>{
          this.detail.residualDownloadTraffic=res.data.residualDownloadTraffic/1
        })
      },
    },
    mounted(){

    },
  }
</script>

<style>
 .border{
     border: 1px solid #ccc;
     padding: 5px;
     border-radius: 5px;
     margin-right: 5px;
 }
 .el-switch__label{
     white-space:nowrap;
     color: #606266;
 }
 .el-switch__label.is-active{
     color: #606266;
 }
 .el-descriptions__header{
     margin-bottom: 10px;
 }
</style>


// WEBPACK FOOTER //
// src/pages/components/activitySetting.vue